import { useCallback } from 'react';
import { useAppStore } from '@/store/appStore';
import { translate, type TranslationKey, type TranslationParams } from '@/i18n';

export type TranslateFn = (key: TranslationKey, params?: TranslationParams) => string;

/** React binding for `translate`: components re-render when the language changes. */
export function useT(): TranslateFn {
  const language = useAppStore((state) => state.language);
  return useCallback<TranslateFn>((key, params) => translate(language, key, params), [language]);
}
